const appendParam = (
  params: URLSearchParams,
  key: string,
  value: string | number | null | undefined,
) => {
  if (value === null || value === undefined) return;
  const normalized = String(value).trim();
  if (!normalized) return;
  params.set(key, normalized);
};

export const buildProjectPanelUrl = (input: {
  clientId?: string | number | null;
  projectId?: string | number | null;
  view?: 'clients' | 'projects' | string | null;
}) => {
  const params = new URLSearchParams();
  appendParam(params, 'view', input.view || 'clients');
  appendParam(params, 'clientId', input.clientId);
  appendParam(params, 'projectId', input.projectId);

  const query = params.toString();
  return query ? `/Project?${query}` : '/Project';
};

export default {
  buildProjectPanelUrl,
};
